import {useStore} from 'vuex'
import startSearch from '../../foundation/js/startSearch'

export default {
    name: "SiteNavigation",
    setup(){
        const store = useStore()
        const closeQuickSearch = startSearch.bind(null,null)

        const openMegaMenu = function(menuId){
            closeQuickSearch(true)
            keepMegaMenuOpen()
            store.commit('main/set_active_mega_menu',menuId)
            store.commit('main/show_overlay')
        }

        const hideMegaMenu = function(){
            store.commit('main/set_active_mega_menu',null)
        }

        const keepMegaMenuOpen = function(){
            if(!!(store.state.main.active_mega_menu)) store.dispatch('main/cancelMegaMenuTimer')
        }

        return {
            hideMegaMenu,
            keepMegaMenuOpen,
            openMegaMenu,
            startSearch
        }
    }
}